// import React from 'react'
// import { FiClock } from 'react-icons/fi'
// import { daysInArabic, timeSlots } from '../../../data/assests'

// const RenderStep3 = (
//     {
//         handleAvailabilityChange,
//         formData,
//     }
// ) => {
//     return (
//         <div className="space-y-6">
//             <div className="text-center mb-6">
//                 <FiClock className="w-12 h-12 text-emerald-600 mx-auto mb-4" />
//                 <h3 className="text-lg font-bold text-gray-800 mb-2">الأوقات المتاحة للعمل</h3>
//                 <p className="text-gray-600 text-sm">حدد الأيام والأوقات التي تفضل العمل فيها</p>
//             </div>

//             {daysInArabic.map((day) => (
//                 <div key={day.key} className="bg-gray-50/50 p-4 rounded-xl">
//                     <h4 className="font-semibold text-gray-800 mb-3">{day.day}</h4>
//                     <div className="grid grid-cols-3 md:grid-cols-4 gap-2">
//                         {timeSlots.map((slot) => (
//                             <button
//                                 key={slot.value}
//                                 type="button"
//                                 onClick={() => handleAvailabilityChange(day.key, slot.value)}
//                                 className={`p-2 border-2 rounded-lg transition-all duration-300 text-sm ${formData.availableTimes.filter(days => days.day === day.key)[0]?.slots?.includes(slot.value)
//                                     ? 'border-emerald-600 bg-emerald-50 text-emerald-700'
//                                     : 'border-gray-200 hover:border-emerald-300 text-gray-700'
//                                     }`}
//                             >
//                                 {slot.label}
//                             </button>
//                         ))}
//                     </div>
//                 </div>
//             ))}
//         </div>
//     )
// }

// export default RenderStep3











// import React, { useState } from 'react'
// import { FiClock } from 'react-icons/fi'
// import { daysInArabic, timeSlots } from '../../../data/assests'

// const RenderStep3 = ({ handleAvailabilityChange, formData }) => {
//   const [selectedDays, setSelectedDays] = useState([])

//   // إضافة أو إزالة اليوم
//   const toggleDay = (dayKey) => {
//     setSelectedDays((prev) =>
//       prev.includes(dayKey) ? prev.filter((d) => d !== dayKey) : [...prev, dayKey]
//     )
//   }

//   return (
//     <div className="space-y-6">
//       <div className="text-center mb-6">
//         <FiClock className="w-12 h-12 text-emerald-600 mx-auto mb-4" />
//         <h3 className="text-lg font-bold text-gray-800 mb-2">الأوقات المتاحة للعمل</h3>
//         <p className="text-gray-600 text-sm">
//           أولاً اختر الأيام التي تعمل بها، ثم حدد ساعات العمل لكل يوم
//         </p>
//       </div>

//       {/* ✅ اختيار الأيام */}
//       <div className="flex flex-wrap gap-2 justify-center">
//         {daysInArabic.map((day) => (
//           <button
//             key={day.key}
//             type="button"
//             onClick={() => toggleDay(day.key)}
//             className={`px-4 py-2 rounded-lg border-2 transition-all ${
//               selectedDays.includes(day.key)
//                 ? 'bg-emerald-50 border-emerald-600 text-emerald-700'
//                 : 'border-gray-200 hover:border-emerald-300 text-gray-700'
//             }`}
//           >
//             {day.day}
//           </button>
//         ))}
//       </div>

//       {/* ✅ تحديد ساعات العمل للأيام المختارة */}
//       {selectedDays.map((dayKey) => {
//         const dayObj = daysInArabic.find((d) => d.key === dayKey)
//         const availability =
//           formData.availableTimes.find((d) => d.day === dayKey) || {}

//         return (
//           <div key={dayKey} className="bg-gray-50/50 p-4 rounded-xl">
//             <h4 className="font-semibold text-gray-800 mb-3">{dayObj.day}</h4>

//             <div className="grid grid-cols-2 gap-4">
//               {/* وقت البداية */}
//               <div>
//                 <label className="block text-sm mb-1 text-gray-600">من</label>
//                 <select
//                   className="w-full border rounded-lg p-2"
//                   value={availability.from || ''}
//                   onChange={(e) =>
//                     handleAvailabilityChange(dayKey, {
//                       from: e.target.value,
//                       to: availability.to || '',
//                     })
//                   }
//                 >
//                   <option value="">-- اختر وقت البداية --</option>
//                   {timeSlots.map((slot) => (
//                     <option key={slot.value} value={slot.value}>
//                       {slot.label}
//                     </option>
//                   ))}
//                 </select>
//               </div>

//               {/* وقت النهاية */}
//               <div>
//                 <label className="block text-sm mb-1 text-gray-600">إلى</label>
//                 <select
//                   className="w-full border rounded-lg p-2"
//                   value={availability.to || ''}
//                   onChange={(e) =>
//                     handleAvailabilityChange(dayKey, {
//                       from: availability.from || '',
//                       to: e.target.value,
//                     })
//                   }
//                 >
//                   <option value="">-- اختر وقت النهاية --</option>
//                   {timeSlots.map((slot) => (
//                     <option key={slot.value} value={slot.value}>
//                       {slot.label}
//                     </option>
//                   ))}
//                 </select>
//               </div>
//             </div>
//           </div>
//         )
//       })}
//     </div>
//   )
// }

// export default RenderStep3









//نهائي



// import React, { useState } from "react";
// import { FiClock } from "react-icons/fi";
// import { daysInArabic } from "../../../data/assests"; // تأكد إنه فيه daysInArabic

// const RenderStep3 = ({ handleAvailabilityChange, formData }) => {
//   const [localTimes, setLocalTimes] = useState({}); 

//   // دالة توليد الأوقات حسب المدة
//   const generateTimeSlots = (start, end, step) => {
//     const slots = [];
//     let [startHour, startMinute] = start.split(":").map(Number);
//     let [endHour, endMinute] = end.split(":").map(Number);

//     let current = new Date();
//     current.setHours(startHour, startMinute, 0, 0);

//     let endTime = new Date();
//     endTime.setHours(endHour, endMinute, 0, 0);

//     while (current <= endTime) {
//       const h = String(current.getHours()).padStart(2, "0");
//       const m = String(current.getMinutes()).padStart(2, "0");
//       slots.push(`${h}:${m}`);
//       current.setMinutes(current.getMinutes() + step);
//     }

//     return slots;
//   };

//   const handleChange = (dayKey, field, value) => {
//     setLocalTimes((prev) => ({
//       ...prev,
//       [dayKey]: {
//         ...prev[dayKey],
//         [field]: value,
//       },
//     }));
//   };

//   const handleGenerate = (dayKey) => {
//     const { start, end, step } = localTimes[dayKey] || {};
//     if (!start || !end || !step) return;

//     const slots = generateTimeSlots(start, end, parseInt(step));
//     handleAvailabilityChange(dayKey, slots); // نرسلها بشكل صحيح للـ formData
//   };

//   return (
//     <div className="space-y-6">
//       <div className="text-center mb-6">
//         <FiClock className="w-12 h-12 text-emerald-600 mx-auto mb-4" />
//         <h3 className="text-lg font-bold text-gray-800 mb-2">
//           الأوقات المتاحة للعمل
//         </h3>
//         <p className="text-gray-600 text-sm">
//           اختر الأيام وساعات العمل وقم بتقسيم الفترات
//         </p>
//       </div>

//       {daysInArabic.map((day) => (
//         <div
//           key={day.key}
//           className="bg-gray-50/50 p-4 rounded-xl space-y-4 shadow-sm"
//         >
//           <h4 className="font-semibold text-gray-800 mb-3">{day.day}</h4>

//           {/* اختيار وقت البداية والنهاية */}
//           <div className="flex gap-4 flex-wrap">
//             <div>
//               <label className="block text-sm mb-1">من</label>
//               <input
//                 type="time"
//                 value={localTimes[day.key]?.start || ""}
//                 onChange={(e) => handleChange(day.key, "start", e.target.value)}
//                 className="border p-2 rounded-md"
//               />
//             </div>
//             <div>
//               <label className="block text-sm mb-1">إلى</label>
//               <input
//                 type="time"
//                 value={localTimes[day.key]?.end || ""}
//                 onChange={(e) => handleChange(day.key, "end", e.target.value)}
//                 className="border p-2 rounded-md"
//               />
//             </div>

//             {/* تقسيم الوقت */}
//             <div>
//               <label className="block text-sm mb-1">التقسيم</label>
//               <select
//                 value={localTimes[day.key]?.step || ""}
//                 onChange={(e) => handleChange(day.key, "step", e.target.value)}
//                 className="border p-2 rounded-md"
//               >
//                 <option value="">اختر</option>
//                 <option value="60">كل ساعة</option>
//                 <option value="30">كل نصف ساعة</option>
//                 <option value="15">كل ربع ساعة</option>
//               </select>
//             </div>

//             {/* زر توليد */}
//             <div className="flex items-end">
//               <button
//                 type="button"
//                 onClick={() => handleGenerate(day.key)}
//                 className="px-4 py-2 bg-emerald-600 text-white rounded-lg hover:bg-emerald-700 transition"
//               >
//                 توليد
//               </button>
//             </div>
//           </div>

//           {/* عرض الأوقات المولدة */}
//           {formData.availableTimes.find((d) => d.day === day.key) && (
//             <div className="mt-3">
//               <h5 className="text-sm text-gray-600 mb-2">الأوقات المختارة:</h5>
//               <div className="flex flex-wrap gap-2">
//                 {formData.availableTimes
//                   .find((d) => d.day === day.key)
//                   ?.slots.map((s, i) => (
//                     <span
//                       key={i}
//                       className="px-3 py-1 bg-emerald-50 text-emerald-700 border border-emerald-200 rounded-lg text-xs"
//                     >
//                       {s}
//                     </span>
//                   ))}
//               </div>
//             </div>
//           )}
//         </div>
//       ))}
//     </div>
//   );
// };

// export default RenderStep3;






// import React from 'react'
// import { FiClock } from 'react-icons/fi'
// import { daysInArabic, timeSlots } from '../../../data/assests'

// const RenderStep3 = ({ handleAvailabilityChange, formData }) => {
//   return (
//     <div className="space-y-6">
//       <div className="text-center mb-6">
//         <FiClock className="w-12 h-12 text-emerald-600 mx-auto mb-4" />
//         <h3 className="text-lg font-bold text-gray-800 mb-2">الأوقات المتاحة للعمل</h3>
//         <p className="text-gray-600 text-sm">حدد الأيام والأوقات التي تفضل العمل فيها (كل 15 دقيقة)</p>
//       </div>

//       {daysInArabic.map((day) => (
//         <div key={day.key} className="bg-gray-50/50 p-4 rounded-xl">
//           <h4 className="font-semibold text-gray-800 mb-3">{day.day}</h4>
//           <div className="grid grid-cols-3 md:grid-cols-6 gap-2 max-h-64 overflow-y-auto">
//             {timeSlots.map((slot) => (
//               <button
//                 key={slot.value}
//                 type="button"
//                 onClick={() => handleAvailabilityChange(day.key, slot.value)}
//                 className={`p-2 border-2 rounded-lg transition-all duration-300 text-xs ${
//                   formData.availableTimes
//                     .filter(d => d.day === day.key)[0]?.slots?.includes(slot.value)
//                     ? 'border-emerald-600 bg-emerald-50 text-emerald-700'
//                     : 'border-gray-200 hover:border-emerald-300 text-gray-700'
//                 }`}
//               >
//                 {slot.label}
//               </button>
//             ))}
//           </div>
//         </div>
//       ))}
//     </div>
//   )
// }

// export default RenderStep3

import React from 'react'
import { FiClock } from 'react-icons/fi'
// import { daysInArabic } from '../../../data/assests'

import { daysInArabic, timeSlots } from '../../../data/assests'

// import { timeSlots } from '../../../utils/timeSlots'   // ← استدعاء الجديد

const RenderStep3 = ({ handleAvailabilityChange, formData }) => {
  return (
    <div className="space-y-6">
      <div className="text-center mb-6">
        <FiClock className="w-12 h-12 text-emerald-600 mx-auto mb-4" />
        <h3 className="text-lg font-bold text-gray-800 mb-2">الأوقات المتاحة للعمل</h3>
        <p className="text-gray-600 text-sm">حدد الأيام والأوقات التي تفضل العمل فيها</p>
      </div>

      {daysInArabic.map((day) => (
        <div key={day.key} className="bg-gray-50/50 p-4 rounded-xl">
          <h4 className="font-semibold text-gray-800 mb-3">{day.day}</h4>
          <div className="grid grid-cols-3 md:grid-cols-4 gap-2">
            {timeSlots.map((slot) => (
              <button
                key={slot.value}
                type="button"
                onClick={() => handleAvailabilityChange(day.key, slot.value)}
                className={`p-2 border-2 rounded-lg transition-all duration-300 text-sm ${
                  formData.availableTimes.filter(days => days.day === day.key)[0]?.slots?.includes(slot.value)
                    ? 'border-emerald-600 bg-emerald-50 text-emerald-700'
                    : 'border-gray-200 hover:border-emerald-300 text-gray-700'
                }`}
              >
                {slot.label}
              </button>
            ))}
          </div>
        </div>
      ))}
    </div>
  )
}

export default RenderStep3
